/* Al-Haq (Oct 2026): first-load fixes. Loads after alhaq-custom.js. */

/* "Read more" text: alhaq-custom.js has now clamped the long blocks. Release
   the early cut-off (alhaq-first-load-css) on anything it left alone. */
(function () {
  document.querySelectorAll(
    '#main-content .collection-banner--description, #main-content .section-rich-text .rte, #main-content [id$="__rich_text_CRGkL8"] .rte'
  ).forEach(function (el) {
    if (!el.classList.contains('alhaq-clamp')) el.classList.add('alhaq-clamp-done');
  });
})();

/* Shoppable video reels only download and play once the section is near the
   screen, and pause when it scrolls away. Before, the first reel (a 14 MB HD
   video) downloaded the moment the homepage opened, competing with the banner
   images and making the first few seconds feel choppy. */
(function () {
  var reels = document.querySelectorAll('.shoppable-video-reels--carousel');
  if (!reels.length || !('IntersectionObserver' in window)) return;
  function current(carousel) {
    return carousel.querySelector('.carousel__slide.is-selected video') ||
      carousel.querySelector('video[data-alhaq-autoplay="true"]');
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = current(entry.target);
      if (!v) return;
      var box = v.closest('.slideshow__slide-video-bg');
      var toggle = box && box.querySelector('.video-controls--play-pause');
      if (entry.isIntersecting) {
        if (toggle && toggle.classList.contains('paused')) return; // customer paused it
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '200px 0px', threshold: 0.25 });
  reels.forEach(function (r) { io.observe(r); });
})();
